<template>
  <v-col fill-height class="services" cols="4" sm="4" md="4">
    <div class="services-frame">
      <v-card class="mb-2" v-for="service in $store.getters.getServices">
        <v-list-item dense class="weekday" color="purple">
          <v-list-item-content>
            <span>{{ getWeekDay(service.date) }}</span>
          </v-list-item-content>
          <div class="data-frame">
            <div class="rating-frame">
              <v-rating
                class="stars"
                v-if="!service.editing"
                right
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="service.rating"
              ></v-rating>
              <span v-if="!service.editing" class="main-comments"
                >({{ (2 * service.rating).toFixed(2) }})</span
              >
            </div>
            <span
              class="comments"
              @click="$router.push('/service/' + service.id)"
              >{{ service.comments.length }} Comentarios</span
            >
          </div>
        </v-list-item>
        <v-card-text>
          <div
            class="platetype"
            v-if="service.recipes.first.length > 0 || service.editing"
          >
            Primer plato
          </div>
          <v-list class="recipes" v-if="service.recipes.first">
            <v-list-item
              class="recipe"
              v-for="(recipe, index) in service.recipes.first"
              dense
            >
              <v-list-item-content>{{ recipe.name }}</v-list-item-content>
              <v-rating
                v-if="!service.editing"
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="recipe.rating"
              ></v-rating>
              <span v-if="!service.editing" class="plate-rating"
                >({{ (2 * recipe.rating).toFixed(2) }})
                {{ recipe.comments }}</span
              >
              <v-btn
                small
                icon
                v-if="service.editing"
                @click="removePlate(service.id, 'first', index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item
              dense
              v-if="service.editing"
              class="recipe"
              @dragover.prevent
              @drop.stop="addRecipe('first', service.id)"
            >
              <div class="dropzone">Arrastra aquí un primer plato</div>
            </v-list-item>
          </v-list>
          <br />
          <div class="platetype">Segundo plato</div>
          <v-list class="recipes">
            <v-list-item
              class="recipe"
              v-for="(recipe, index) in service.recipes.second"
              dense
            >
              <v-list-item-content>{{ recipe.name }}</v-list-item-content>
              <v-rating
                v-if="!service.editing"
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="recipe.rating"
              ></v-rating>
              <span v-if="!service.editing" class="plate-rating"
                >({{ (2 * recipe.rating).toFixed(2) }})
                {{ recipe.comments }}</span
              >
              <v-btn
                small
                icon
                v-if="service.editing"
                @click="removePlate(service.id, 'second', index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item
              dense
              v-if="service.editing"
              class="recipe"
              @dragover.prevent
              @drop.stop="addRecipe('second', service.id)"
            >
              <div class="dropzone">Arrastra aquí un segundo plato</div>
            </v-list-item>
          </v-list>
          <br />
          <div
            class="platetype"
            v-if="service.recipes.first.length > 0 || service.editing"
          >
            Postre
          </div>
          <v-list class="recipes" v-if="service.recipes.desert">
            <v-list-item
              class="recipe"
              v-for="(recipe, index) in service.recipes.desert"
              dense
            >
              <v-list-item-content>{{ recipe.name }}</v-list-item-content>
              <v-rating
                v-if="!service.editing"
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="recipe.rating"
              ></v-rating>
              <span v-if="!service.editing" class="plate-rating"
                >({{ (2 * recipe.rating).toFixed(2) }})
                {{ recipe.comments }}</span
              >
              <v-btn
                small
                icon
                v-if="service.editing"
                @click="removePlate(service.id, 'desert', index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item
              dense
              v-if="service.editing"
              class="recipe"
              @dragover.prevent
              @drop.stop="addRecipe('desert', service.id)"
            >
              <div class="dropzone">Arrastra aquí un postre</div>
            </v-list-item>
          </v-list>
          <br />
          <div class="platetype">Guarnición</div>
          <v-list class="recipes">
            <v-list-item
              class="recipe"
              v-for="(recipe, index) in service.recipes.garnish || []"
              dense
            >
              <v-list-item-content>{{ recipe.name }}</v-list-item-content>
              <v-rating
                v-if="!service.editing"
                half-increments
                readonly
                small
                dense
                color="green"
                background-color="green"
                :value="recipe.rating"
              ></v-rating>
              <span v-if="!service.editing" class="plate-rating"
                >({{ (2 * recipe.rating).toFixed(2) }})
                {{ recipe.comments }}</span
              >
              <v-btn
                small
                icon
                v-if="service.editing"
                @click="removePlate(service.id, 'garnish', index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item>
            <v-list-item
              dense
              v-if="service.editing"
              class="recipe"
              @dragover.prevent
              @drop.stop="addRecipe('garnish', service.id)"
            >
              <div class="dropzone">Arrastra aquí una guarnición</div>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions v-if="service.editing">
          <v-select
            :items="groups"
            dense
            small
            label="Encuesta en ..."
            class="group-select"
            @change="putGroup($event, service.id)"
          ></v-select>
        </v-card-actions>
        <v-card-actions v-if="!service.editing">
          <v-spacer></v-spacer>
          <div class="group-container">
            <span class="group"
              >{{ service.group.split(":")[1] }} de
              {{ service.group.split(":")[0] }}</span
            >
            <span class="code">{{ service.code }}</span>
          </div>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-actions height="40" v-if="service.comments.length === 0">
          <v-dialog v-model="deleteServiceDialog" width="400">
            <template v-slot:activator="{ on }">
              <v-btn small text v-on="on">Eliminar</v-btn>
            </template>
            <v-card>
              <v-toolbar flat dark color="primary">
                <v-card-title class="font-weight-light"
                  >Eliminar Servicio</v-card-title
                >
              </v-toolbar>
              <v-card-text class="pa-4">
                ¿Seguro que quieres eliminar definitivamente el servicio?
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn small text @click="deleteServiceDialog = false"
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn small text color="red" @click="deleteService(service)"
                  >Confirmar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!service.editing"
            small
            text
            @click="editService(service)"
            >Editar</v-btn
          >
          <v-btn
            v-if="service.editing"
            text
            small
            color="primary"
            @click="confirmService(service)"
            >Confirmar cambios</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </v-col>
</template>

<script>
import firebase from "firebase";
import moment from "moment";

export default {
  data() {
    return {
      deleteServiceDialog: false,
      db: firebase.firestore(),
      newDate: new Date().toISOString().substr(0, 10),
      services: [],
      groups: [],
    };
  },
  created: function () {
    moment.locale("es");
    this.$store.dispatch("readServices");
    firebase
      .firestore()
      .collection("config")
      .get()
      .then((ref) => {
        ref.docs[0].data().cursos.forEach((element) => {
          this.groups.push(element);
        });
      });
  },
  methods: {
    deleteService(service) {
      firebase
        .firestore()
        .collection("services")
        .doc(service.id)
        .delete()
        .then(() => {
          this.deleteServiceDialog = false;
        });
    },
    editService(service) {
      firebase.firestore().collection("services").doc(service.id).update({
        editing: true,
      });
    },
    confirmService(service) {
      firebase.firestore().collection("services").doc(service.id).update({
        editing: false,
      });
    },
    putGroup: function (event, s) {
      firebase.firestore().collection("services").doc(s).update({
        group: event,
      });
    },
    getDate: function (date) {
      return moment(date.seconds * 1000).format("LL");
    },
    getWeekDay: function (date) {
      return moment(date.seconds * 1000).format("dddd D");
    },
    getInitMonth: function () {
      return this.initMonth;
    },
    getEndMonth: function () {
      return this.initMonth;
    },
    getServices: function () {
      this.$store.dispatch("readServices");
    },
    addRecipe: function (type, service) {
      this.$store.dispatch("addRecipe", { type, service });
      console.log(type, service);
    },
    removePlate: function (service, type, index) {
      let serviceRef = firebase.firestore().collection("services").doc(service);
      serviceRef.get().then((ref) => {
        let recipes = ref.data().recipes;
        recipes[type].splice(index, 1);
        serviceRef.update({
          recipes: recipes,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.weekday {
  font-size: 0.8em;
  text-transform: uppercase;
  background-color: grey;
  color: white;
  line-height: 20px;
  padding-left: 10px;
  font-weight: bold;
}
.platetype {
  font-size: 0.8em;
  text-transform: uppercase;
  border-left: 10px solid black;
  line-height: 8px;
  padding-left: 5px;
  padding-top: 1px;
  font-weight: bold;
  margin-bottom: 10px;
}

.recipes {
  padding: 0px;
  border: none;
  .recipe {
    margin: 0px;
    border: none;
    padding-left: 8px;
    padding-right: 8px;
  }
  .recipe:nth-child(odd) {
    background-color: lightgrey;
  }
  .recipe:nth-child(even) {
    border-left: 1px solid lightgrey;
    border-right: 1px solid lightgrey;
  }
  .recipe:last-child {
    border-bottom: 1px solid lightgrey;
  }
  .dropzone {
    border: 1px dashed grey;
    width: fill;
    text-align: center;
    border-radius: 5px;
    padding: 0px;
    margin: 0px;
    background-color: rgb(238, 238, 238);
    color: grey;
    height: 30px;
    line-height: 28px;
    font-weight: bold;
  }
  .dropzone:hover {
    background-color: white;
  }
}
.group-container {
  display: block;
  width: fill;
  margin: 7px;
  .group {
  }
  .code {
    float: right;
    color: grey;
    font-weight: bold;
  }
}
.services {
  position: relative;
  height: 100%;
  overflow: scroll;
}
.data-frame {
  text-align: right;
  .rating-frame {
    display: inline-block;
    .stars {
      display: inline-block;
    }
    .rating {
      font-size: 0.8em;
      width: 40px;
      text-align: center;
      font-weight: bold;
    }
  }
  .comments {
    font-size: 0.8em;
    cursor: pointer;
    text-decoration: underline;
    display: block;
    margin-top: 0px;
    margin-bottom: 3px;
  }
}
.plate-rating {
  height: 20px;
  line-height: 22px;
  font-size: 0.8em;
  width: 60px;
  text-align: center;
  font-weight: bold;
  color: grey;
}
.group-select {
  margin: 7px;
}
</style>